import { ActionTypesFactory } from "../../config/helper";

export const Register = ActionTypesFactory("Auth", "Register");
export const PriceWorker = ActionTypesFactory("Auth", "PriceWorker");
export const NewPassoword = ActionTypesFactory("Auth", "NewPassoword");
export const Sessions = ActionTypesFactory("Auth", "Sessions");
export const SelectCustomer = ActionTypesFactory("Auth", "SelectCustomer");
export const ForgotPassoword = ActionTypesFactory("Auth", "ForgotPassoword");
export const ResetPassoword = ActionTypesFactory("Auth", "ResetPassoword");
export const UserDashboard = ActionTypesFactory("Auth", "UserDashboard");
export const UserProfile = ActionTypesFactory("Auth", "UserProfile");
export const Notifications = ActionTypesFactory("Auth", "Notifications");
export const Marketings = ActionTypesFactory("Auth", "Marketings");
export const WarrentyDocs = ActionTypesFactory("Auth", "WarrentyDocs");
export const Timezone = ActionTypesFactory("Auth", "Timezone");
export const Logout = ActionTypesFactory("Auth", "Logout");
export const CreateDelegateUser = ActionTypesFactory("Auth", "CreateDelegateUser");
export const GetDelegateUsers = ActionTypesFactory("Auth", "GetDelegateUsers");
export const DeleteDelegateUser = ActionTypesFactory("Auth", "DeleteDelegateUser");
export const UpdateDelegateUser = ActionTypesFactory("Auth", "UpdateDelegateUser");


export const register = (payload) => {
  return {
    type: Register.REQUEST,
    payload,
  };
};

export const price_worker = (payload) => {
  return {
    type: PriceWorker.REQUEST,
    payload,
  };
};

export const get_timezone = (payload) => {
  return {
    type: Timezone.REQUEST,
    payload,
  };
};

export const notifications = () => {
  return {
    type: Notifications.REQUEST,
  };
};

export const get_marketings = (payload) => {
  return {
    type: Marketings.REQUEST,
    payload
  };
};

export const get_warrentyDocs = () => {
  return {
    type: WarrentyDocs.REQUEST,
  };
};

export const get_dashboard = (payload) => {
  return {
    type: UserDashboard.REQUEST,
    payload,
  };
};

export const reset_register = () => {
  return {
    type: Register.RESET,
  };
};

export const sessions = (payload) => {
  return {
    type: Sessions.REQUEST,
    payload,
  };
};

export const select_customer = (payload) => {
  return {
    type: SelectCustomer.REQUEST,
    payload,
  };
};

export const reset_sessions = () => {
  return {
    type: Sessions.RESET,
  };
};

export const new_password = (payload) => {
  return {
    type: NewPassoword.REQUEST,
    payload,
  };
};

export const forgot_password = (payload) => {
  return {
    type: ForgotPassoword.REQUEST,
    payload,
  };
};

export const reset_password = (payload) => {
  return {
    type: ResetPassoword.REQUEST,
    payload,
  };
};

export const user_profile = (payload) => {
  return {
    type: UserProfile.REQUEST,
    payload,
  };
};

export const logout = (payload) => {
  return {
    type: Logout.REQUEST,
    payload,
  };
};

export const get_delegate_users = (payload) => {
  return {
    type: GetDelegateUsers.REQUEST,
    payload,
  };
};

export const delete_delegate_user = (payload) => ({
  type: DeleteDelegateUser.REQUEST,
  payload,
});

export const update_delegate_user = (payload) => ({
  type: UpdateDelegateUser.REQUEST,
  payload,
});

export const create_delegate_user = (payload) => {
  return { type: CreateDelegateUser.REQUEST, payload };
};